export const STATUS = {
  AVAILABLE: 'AVAILABLE',
  AWAY: 'AWAY',
};
export const STATUSES = Object.values(STATUS);
